// Grid template compartido entre el header (PackageGroup) y las filas (AnexoItemRow).
// Mantiene alineadas las columnas de descripción / cant / unidad / FOB unit / FOB total / delete.
export const ANEXO_ITEM_GRID = 'grid-cols-[minmax(180px,1fr)_72px_96px_88px_88px_32px]';
